import moment from 'moment';
import { withParams } from 'vuelidate';
export default (format, date) =>
	withParams({ type: 'dateGreaterThanOrEqual', format, date }, function (value) {
		if (typeof value === 'undefined' || value === null || value === '' || !moment(value, format, true).isValid()) {
			return true;
		}
		return !moment(value, format).isBefore(date);
	});
